"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "DefaultError", {
  enumerable: true,
  get: function get() {
    return _DefaultError.default;
  }
});
Object.defineProperty(exports, "DefaultLoader", {
  enumerable: true,
  get: function get() {
    return _DefaultLoader.default;
  }
});
exports.default = exports.RenderMode = void 0;
require("regenerator-runtime/runtime");
require("url-polyfill");
require("react-intl");
var _modalLoaderUtils = require("@wsb/modal-loader-utils");
var _DefaultError = _interopRequireDefault(require("./components/DefaultError"));
var _DefaultLoader = _interopRequireDefault(require("./components/DefaultLoader"));
var _Manager = _interopRequireDefault(require("./components/Manager"));
var RenderMode = exports.RenderMode = _modalLoaderUtils.CONSTANTS.RenderMode;
var _default = exports.default = _Manager.default;